import React, { useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { getSpecialCountTime } from "../../../utils/camp.utils";

const SpecialCamp = ({ specialCampProp }) => {
    const [isComplete, setIsComplete] = useState(false);

    const getSchedule = () => {

        const convertedTime = getSpecialCountTime(
            specialCampProp.start_date,
            specialCampProp.time_zone
        );
        // if (Number(convertedTime) < Date.now()) setIsComplete(true)
        return `${convertedTime}`;

        // return getCampStatus(campStatus) || '';
    };

    const HandleComplete = () => <p className="time">Event Completed</p>

    const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return <HandleComplete />
        } else {
            return (
                <span>
                    {days}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
                </span>
            );
        }
    };

    return (
        <>


            <Countdown
                date={Date.now() + Number(getSchedule())}
                renderer={countdownRenderer}
                className="time"
            // overtime={true}
            // onComplete={handleComplete}
            >
                <HandleComplete />
            </Countdown>

        </>
    )
}

export default SpecialCamp;